export default "__VITE_ASSET__kK8Ra3H$__"